import withSettingsColor from './with-settings-color';

export default withSettingsColor({
  propName: 'dividerColor',
  siteColorFallback: 'color-5',
  siteColorAlpha: 0.2,
  fallbackColor: 'rgba(51, 51, 51, 0.2)',
});
